export const specialCharacters = [
  { code: '&#8212', name: 'Em-dash' },
  { code: '&#94;', name: 'Caret' },
  { code: '&#95;', name: 'Underscore' },
  { code: '&#96;', name: 'Grave / accent' },
  { code: '&#123;', name: 'Left curly bracket' },
  { code: '&#124;', name: 'Vertical bar' },
  { code: '&#125;', name: 'Right curly bracket' },
  { code: '&#126;', name: 'Tilde' },
  { code: '&#160;', name: 'Non-breaking space' },
  { code: '&#161;', name: 'Inverted exclamation mark' },
  { code: '&#162;', name: 'Cent sign' },
  { code: '&#163;', name: 'Pound sign' },
  { code: '&#164;', name: 'Currency sign' },
  { code: '&#165;', name: 'Yen sign' },
  { code: '&#166;', name: 'Broken bar' },
  { code: '&#167;', name: 'Section sign' },
  { code: '&#168;', name: 'Diaeresis' },
  { code: '&#169;', name: 'Copyright sign' },
  { code: '&#174;', name: 'Registered sign' },
  { code: '&#8482;', name: 'Trademark' },
  { code: '&#170;', name: 'Feminine ordinal indicator' },
  { code: '&#171;', name: 'Left pointing guillemet' },
  { code: '&#172;', name: 'Not sign' },
  { code: '&#175;', name: 'Macron' },
  { code: '&#176;', name: 'Degree sign' },
  { code: '&#177;', name: 'Plus-minus sign' },
  { code: '&#178;', name: 'Superscript two' },
  { code: '&#179;', name: 'Superscript three' },
  { code: '&#180;', name: 'Acute accent' },
  { code: '&#181;', name: 'Micro sign' },
  { code: '&#182;', name: 'Paragraph sign' },
  { code: '&#183;', name: 'Middle dot' },
  { code: '&#184;', name: 'Spacing cedilla' },
  { code: '&#185;', name: 'Superscript one' },
  { code: '&#186;', name: 'Masculine ordinal indicator' },
  { code: '&#187;', name: 'Right pointing guillemet' },
  { code: '&#188;', name: 'Fraction one quarter' },
  { code: '&#189;', name: 'Fraction one half' },
  { code: '&#190;', name: 'Fraction three quarters' },
  { code: '&#191;', name: 'Inverted question mark' },
  { code: '&#192;', name: 'Capital A with grave' },
  { code: '&#193;', name: 'Capital A with acute' },
  { code: '&#194;', name: 'Capital A with circumflex' },
  { code: '&#195;', name: 'Capital A with tilde' },
  { code: '&#9745;', name: 'Check box with check' },
  { code: '&#9746;', name: 'Check box with X' },
  { code: '&#9744;', name: 'Unchecked box' },
  { code: '&#x2713', name: 'Check mark' },
];
